import Vue from "vue";
import { Auth } from "../";

Vue.directive("auth", {
  inserted(el, binding, vnode) {
    if (!vnode.elm) {
      return;
    }

    if (binding.arg === "anonymous" && Auth.claims) {
      vnode.elm.parentElement!.removeChild(vnode.elm);
      return;
    }

    if (!Auth.claims) {
      vnode.elm.parentElement!.removeChild(vnode.elm);
      return;
    }

    if (binding.arg === "roles" && !Auth.isInRole(...(binding.value as string[]))) {
      vnode.elm.parentElement!.removeChild(vnode.elm);
    }
  },
});
